// extracted by mini-css-extract-plugin
module.exports = {"row":"SimpleQuestionBuilderModal_row__2aI_-","radioRow":"SimpleQuestionBuilderModal_radioRow__3a5bm"};